import { createTheme } from '@mui/material/styles';

// 시설 테마 색상 팔레트 - 접근성 개선된 버전
export const theme = createTheme({
    palette: {
        primary: {
            main: '#0077B6', // 시설 물색 - 접근성 개선됨
            light: '#00B4D8',
            dark: '#005F8E',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#03045E', // 짙은 파란색
            light: '#023E8A',
            dark: '#010330',
            contrastText: '#ffffff',
        },
        error: {
            main: '#E63946', // 빨간색 (경고/위험) - 접근성 개선됨
            light: '#FF5A69',
            dark: '#C01023',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#F48C06', // 주황색 (주의) - 접근성 개선됨
            light: '#FFB703',
            dark: '#D67700',
            contrastText: '#000000',
        },
        info: {
            main: '#0096C7', // 하늘색 - 접근성 개선됨 (더 어두운 색으로)
            light: '#48CAE4',
            dark: '#0077B6',
            contrastText: '#ffffff',
        },
        success: {
            main: '#2DC653', // 녹색 (안전) - 접근성 개선됨
            light: '#57D97A',
            dark: '#1CA243',
            contrastText: '#000000',
        },
        background: {
            default: '#F8FAFC', // 매우 밝은 블루 그레이
            paper: '#ffffff',
        },
        grey: {
            50: '#F8FAFC',
            100: '#F1F5F9',
            200: '#E2E8F0',
            300: '#CBD5E1',
            400: '#94A3B8',
            500: '#64748B',
            600: '#475569',
            700: '#334155',
            800: '#1E293B',
            900: '#0F172A',
        },
        text: {
            primary: '#1E293B', // 더 어둡게 해서 대비 향상
            secondary: '#475569',
            disabled: '#64748B', // 더 어둡게 해서 접근성 향상
        },
    },
    typography: {
        fontFamily: [
            'Inter',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h1: {
            fontSize: '2.5rem',
            fontWeight: 700,
            letterSpacing: '-0.01em',
            lineHeight: 1.2, // 접근성 향상: 라인 높이 추가
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 700,
            letterSpacing: '-0.01em',
            lineHeight: 1.3, // 접근성 향상: 라인 높이 추가
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            lineHeight: 1.4, // 접근성 향상: 라인 높이 추가
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            lineHeight: 1.4, // 접근성 향상: 라인 높이 추가
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            lineHeight: 1.5, // 접근성 향상: 라인 높이 추가
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            lineHeight: 1.5, // 접근성 향상: 라인 높이 추가
        },
        subtitle1: {
            fontSize: '1rem',
            fontWeight: 500,
            letterSpacing: '-0.01em',
            lineHeight: 1.5, // 접근성 향상: 라인 높이 추가
        },
        subtitle2: {
            fontSize: '0.875rem',
            fontWeight: 500,
            letterSpacing: '-0.01em',
            lineHeight: 1.5, // 접근성 향상: 라인 높이 추가
        },
        body1: {
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.6, // 접근성 향상: 라인 높이 추가
        },
        body2: {
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.6, // 접근성 향상: 라인 높이 추가
        },
        button: {
            fontSize: '0.875rem',
            fontWeight: 600,
            textTransform: 'none',
            letterSpacing: '0.02em',
        },
        caption: {
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: 1.4, // 접근성 향상: 라인 높이 추가
        },
        overline: {
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em', // 접근성 향상: 줄였음
            lineHeight: 1.5, // 접근성 향상: 라인 높이 추가
        },
    },
    shape: {
        borderRadius: 12,
    },
    shadows: [
        'none',
        '0px 1px 2px rgba(15, 23, 42, 0.05)',
        '0px 2px 4px rgba(15, 23, 42, 0.08)',
        '0px 4px 8px rgba(15, 23, 42, 0.1)',
        '0px 8px 16px rgba(15, 23, 42, 0.12)',
        '0px 16px 24px rgba(15, 23, 42, 0.14)',
        '0px 24px 32px rgba(15, 23, 42, 0.16)',
        '0px 32px 40px rgba(15, 23, 42, 0.18)',
        '0px 40px 48px rgba(15, 23, 42, 0.2)',
        '0px 48px 56px rgba(15, 23, 42, 0.22)',
        '0px 56px 64px rgba(15, 23, 42, 0.24)',
        '0px 64px 72px rgba(15, 23, 42, 0.26)',
        '0px 72px 80px rgba(15, 23, 42, 0.28)',
        '0px 80px 88px rgba(15, 23, 42, 0.3)',
        '0px 88px 96px rgba(15, 23, 42, 0.32)',
        '0px 96px 104px rgba(15, 23, 42, 0.34)',
        '0px 104px 112px rgba(15, 23, 42, 0.36)',
        '0px 112px 120px rgba(15, 23, 42, 0.38)',
        '0px 120px 128px rgba(15, 23, 42, 0.4)',
        '0px 128px 136px rgba(15, 23, 42, 0.42)',
        '0px 136px 144px rgba(15, 23, 42, 0.44)',
        '0px 144px 152px rgba(15, 23, 42, 0.46)',
        '0px 152px 160px rgba(15, 23, 42, 0.48)',
        '0px 160px 168px rgba(15, 23, 42, 0.5)',
        '0px 168px 176px rgba(15, 23, 42, 0.52)',
    ],
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    overflowX: 'hidden',
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    width: '100%',
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px',
                    fontWeight: 600,
                    transition: 'all 0.2s ease-in-out',
                },
                contained: {
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    '&:hover': {
                        boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                        transform: 'translateY(-1px)',
                    },
                },
                outlined: {
                    borderWidth: '1.5px',
                    '&:hover': {
                        borderWidth: '1.5px',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.1)',
                },
                elevation1: {
                    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.05), 0 1px 2px rgba(15, 23, 42, 0.1)',
                },
                elevation2: {
                    boxShadow: '0 2px 6px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.12)',
                },
                elevation3: {
                    boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.14)',
                },
                elevation4: {
                    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.1), 0 4px 8px rgba(15, 23, 42, 0.16)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    overflow: 'hidden',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
                    },
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: 24,
                    '&:last-child': {
                        paddingBottom: 24,
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '12px 16px',
                    borderColor: '#E2E8F0',
                },
                head: {
                    backgroundColor: '#F8FAFC',
                    fontWeight: 600,
                    color: '#1E293B',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 500,
                },
                sizeSmall: {
                    height: 24,
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    boxShadow: '0 24px 48px rgba(15, 23, 42, 0.16)',
                    /* 모바일만 전폭 — sm 이상은 Dialog maxWidth prop(lg/md 등) 따름 */
                    '@media (max-width:599.95px)': {
                        margin: 12,
                        width: 'calc(100% - 24px)',
                        maxWidth: 'calc(100% - 24px)',
                    },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '20px 24px 16px',
                    fontSize: '1.25rem',
                    fontWeight: 600,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '8px 24px 20px',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '12px 24px 24px',
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8,
                        '& fieldset': {
                            borderColor: '#CBD5E1',
                            transition: 'border-color 0.2s ease-in-out',
                        },
                        '&:hover fieldset': {
                            borderColor: '#94A3B8',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#0077B6',
                            borderWidth: '1.5px',
                        },
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    '&.Mui-focused': {
                        color: '#0077B6',
                    },
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    transition: 'all 0.2s ease-in-out',
                    '&.Mui-selected': {
                        color: '#0077B6',
                    },
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: '0 2px 4px rgba(15, 23, 42, 0.08)',
                },
                standardSuccess: {
                    backgroundColor: 'rgba(45, 198, 83, 0.1)',
                    color: '#1CA243',
                },
                standardInfo: {
                    backgroundColor: 'rgba(72, 202, 228, 0.1)',
                    color: '#0096C7',
                },
                standardWarning: {
                    backgroundColor: 'rgba(244, 140, 6, 0.1)',
                    color: '#D67700',
                },
                standardError: {
                    backgroundColor: 'rgba(230, 57, 70, 0.1)',
                    color: '#C01023',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(0, 119, 182, 0.08)',
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: 'rgba(0, 119, 182, 0.12)',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.05), 0 1px 2px rgba(15, 23, 42, 0.1)',
                },
                colorPrimary: {
                    backgroundColor: '#ffffff',
                    color: '#1E293B',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    minHeight: '64px',
                },
            },
        },
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(203, 213, 225, 0.4)',
                },
            },
        },
    },
}); 